import { render, staticRenderFns } from "./mobile-attachment.component.vue?vue&type=template&id=753881e6&scoped=true"
import script from "./mobile-attachment.component.vue?vue&type=script&lang=js"
export * from "./mobile-attachment.component.vue?vue&type=script&lang=js"
import style0 from "./mobile-attachment.component.vue?vue&type=style&index=0&id=753881e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753881e6",
  null
  
)

export default component.exports